import React, { useEffect } from 'react';
import './NotFound.css';
import logo from '../assets/LED-Speed-Signs-Logo.png';

const Unauthorized = () => {
  
  useEffect(() => {
    localStorage.clear();
    window.location.href = '/#/landing';
  }, []); 

  return (
    <div className="not-found">
      <img src={logo} alt="Logo" className="logo" />
      <h1>401 - Unauthorized Access</h1>
      <a href="/#/landing">Go Back</a>
    </div>
  );
};

export default Unauthorized;
